import React from 'react';
const tomos = [{
  emoji: '📘',
  num: 'Tomo 1',
  age: '6–7 años · 1.º',
  title: 'Lógica inicial y operaciones básicas',
  desc: 'Sistema numérico inicial, lógica matemática y primeras sumas y restas con apoyo visual.',
  color: '#8B5CF6'
}, {
  emoji: '📗',
  num: 'Tomo 2',
  age: '7–8 años · 2.º',
  title: 'Consolidación y geometría inicial',
  desc: 'Dominio de sumas, restas con llevadas y primer acercamiento a figuras y formas.',
  color: '#22C55E'
}, {
  emoji: '📙',
  num: 'Tomo 3',
  age: '8–9 años · 3.º',
  title: 'Multiplicación y resolución de retos',
  desc: 'El mundo de la multiplicación, tablas y problemas razonados paso a paso.',
  color: '#F59E0B'
}, {
  emoji: '📕',
  num: 'Tomo 4',
  age: '9–10 años · 4.º',
  title: 'División, fracciones y medidas',
  desc: 'División avanzada, introducción a fracciones, medidas y cuerpos geométricos.',
  color: '#EF4444'
}, {
  emoji: '📓',
  num: 'Tomo 5',
  age: '10–11 años · 5.º',
  title: 'Decimales y proporcionalidad',
  desc: 'Decimales, porcentajes, proporcionalidad y primer manejo de datos y estadística.',
  color: '#3B82F6'
}, {
  emoji: '📒',
  num: 'Tomo 6',
  age: '11–12 años · 6.º',
  title: 'Pensamiento lógico avanzado',
  desc: 'Razonamiento abstracto y preparación sólida para el ingreso a secundaria.',
  color: '#0EA5E9'
}];
export function BenefitsSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <div className="text-center mb-14" data-id="element-3">
          <p className="text-primary font-bold uppercase tracking-wider text-xs sm:text-sm mb-3" data-id="element-4">
            📚 Currículo Completo
          </p>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-5">
            ¿Qué hay dentro?{' '}
            <span className="text-primary" data-id="element-6">Grado por grado.</span>
          </h2>
          <p className="text-text-sec text-base sm:text-lg max-w-2xl mx-auto" data-id="element-7">
            Toda la Primaria / Educación Básica organizada en{' '}
            <span className="text-primary font-bold" data-id="element-8">6 Tomos Anuales</span>, uno
            para cada nivel.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-9">
          {tomos.map((t, i) => <div key={i} className="bg-bg-alt p-7 rounded-3xl border border-border-light shadow-md flex flex-col gap-3 hover:-translate-y-1 hover:shadow-xl transition-all duration-300 relative overflow-hidden group" data-id="element-10">
              <div className="absolute top-0 left-0 w-full h-1.5" style={{
            backgroundColor: t.color
          }} data-id="element-11" />

              <div className="flex items-center gap-3 mb-1 mt-1" data-id="element-12">
                <div className="w-14 h-14 rounded-2xl flex items-center justify-center text-3xl shadow-inner" style={{
              backgroundColor: `${t.color}15`,
              border: `1px solid ${t.color}40`
            }} data-id="element-13">
                  {t.emoji}
                </div>
                <div data-id="element-14">
                  <p className="font-black text-sm" style={{
                color: t.color
              }} data-id="element-15">
                    {t.num}
                  </p>
                  <p className="text-text-sec text-xs font-medium" data-id="element-16">{t.age}</p>
                </div>
              </div>

              <h3 className="text-lg sm:text-xl font-bold text-text-main leading-snug" data-id="element-17">
                {t.title}
              </h3>
              <p className="text-text-sec leading-relaxed text-sm sm:text-base" data-id="element-18">
                {t.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}